// @ts-check
import React from 'react';
import Header from './Header';

/**
 * @returns {React.ReactElement}
 */
const Home = () => {
  return (
    <React.Fragment>
      <Header />
    </React.Fragment>
  );
};

export default Home;
